function exportHTML(content, title, author, customStyles) {
    let filename = title + ".html" ? title : 'untitled.html';
    // Extract the styles from the document
    const styles = Array.from(document.querySelectorAll('style, link[rel="stylesheet"]'))
        .map(link => link.outerHTML)
        .join('\n');

    console.log(styles)

    // Include external KaTeX CSS if you're using KaTeX
    const katexStyles = '<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/katex@0.12.0/dist/katex.min.css">';
    const cmFontStylesheet = '<link rel="stylesheet" type="text/css" href="https://cdn.jsdelivr.net/gh/aaaakshat/cm-web-fonts@latest/fonts.css">';
    const codeStyles = "<link rel='stylesheet' href='https://cdn.jsdelivr.net/npm/highlight.js/styles/github.css'>"
    // Additional styles for exported content
    const exportStyles = `
        <style>
            body {
                overflow: auto; /* Ensure the body is scrollable */
                padding: 10px 120px 0 100px;
                font-family: 'Computer-Modern', 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
            }
        </style>
    `;

    const footerHtml = `
    <footer style="text-align: center; margin-top: 20px; padding: 10px 0; font-size: 0.8em; color: #666;">
        Made with <strong>MarkTeX</strong> by ${author ? author : 'Anonymous'}<br>
    </footer>
`;
    const fullHtml = `
        <!DOCTYPE html>
        <html lang="en">
        <head>
        <meta charset="utf-8">
            <title>${title}</title>
            ${styles}
            ${cmFontStylesheet}
            ${katexStyles}
            ${codeStyles}
            ${customStyles}
            ${exportStyles}
        </head>
        <body>
            ${content}
            ${footerHtml}
        </body>
        </html>`;

    const blob = new Blob([fullHtml], { type: 'text/html' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

export default exportHTML;